import { isBrowser } from '../window';

/**
 * Preserves current page's query params and hash when navigating to maintain campaign tracking.
 * Properly merges query parameters using native URL APIs.
 *
 * @param url - The target URL (can be relative or absolute)
 * @returns URL with preserved query params and hash
 */
export function preserveUrlParams(url: string): string {
  if (!isBrowser()) {
    return url;
  }

  const currentSearch = window.location.search; // e.g., "?utm_source=google"
  const currentHash = window.location.hash; // e.g., "#section1"

  if (!currentSearch && !currentHash) {
    return url;
  }

  // Use a dummy base URL to safely parse relative paths (e.g., "/about")
  const dummyBase = 'https://temporary-base.com';
  const parsedUrl = new URL(url, dummyBase);

  if (currentSearch) {
    const currentParams = new URLSearchParams(currentSearch);
    // Append or overwrite target URL params with current page params
    currentParams.forEach((value, key) => {
      parsedUrl.searchParams.set(key, value);
    });
  }

  // Preserve hash (target URL hash takes priority, falls back to current page hash)
  if (!parsedUrl.hash && currentHash) {
    parsedUrl.hash = currentHash;
  }

  // Return the final string (strip the dummy base if the original URL was relative)
  const isRelative = !url.startsWith('http://') && !url.startsWith('https://') && !url.startsWith('//');

  return isRelative ? parsedUrl.pathname + parsedUrl.search + parsedUrl.hash : parsedUrl.href;
}
